// extracted by mini-css-extract-plugin
export default {"root":"LeftNavIcon_root__gtN3n","selected":"LeftNavIcon_selected__fIm86"};